export const REVIEWS_OF_PURCHASE_ITEM_API_END_POINT = process.env.RAZZLE_REVIEWS_OF_PURCHASE_ITEM_API_END_POINT || 'purchaseitems-reviews-of-products'
export const BASE_API_URL = process.env.RAZZLE_BASE_API_URL
